/**
 * Helper function that determines if third party cookies are enabled in the current browsing context.
 * 
 * @param {String} iFrameUri
 * @param {Function} callBack
 */
export function checkCookie(iFrameUri, callBack) {

  const messageHandler = (event) => {
    
    if (['webpackOk'].includes(event && event.data && event.data.type)) return;
    const data = JSON.parse(event && event.data);
    if (!data) return;
    callBack(data['result']);
    window.removeEventListener('message', messageHandler);
    document.body.removeChild(frame);
  };

  window.addEventListener('message', messageHandler);
  const frame = document.createElement('iframe');
  frame.src = iFrameUri;
  frame.sandbox = 'allow-scripts allow-same-origin';
  frame.style = `display:none`;
  frame.onload = (e) => {
    frame.contentWindow.postMessage(JSON.stringify({ test: 'cookie' }), '*');
  };

  document.body.appendChild(frame);
}
